export default {
  SELF: {
    title: 'Sue it yourself',
    value: 0
  },
  FEE:{
    title: 'Honorar',
    value: 1
  },
  RSV: {
    title: 'Rechtsschutzversicherung',
    value: 2
  },
  IMMEDIATELY: {
    title: 'Sofortgeld',
    value: 3
  },
  COMMISSION: {
    title: 'Provision',
    value: 4
  }
};
